import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from './config.service';
import { WelcomeTourSlide } from "../models/welcome-tour/welcome-tour-slide";
import { WelcomeTourPatch } from "../components/welcome-tour/welcome-tour.component";




@Injectable()
export class WelcomeTourService {
    constructor(
        private http: HttpClient,
        private configService: ConfigService) {
    }

    showWelcomeTour(organisationReference: string): Observable<boolean> {
        return this.http.get<boolean>(`${ this.configService.baseUrl }/manage/organisation/${organisationReference}/welcome-tour/show`);
    }

    getWelcomeTour(organisationReference: string): Observable<WelcomeTourSlide[]> {
        return this.http.get<WelcomeTourSlide[]>(`${ this.configService.baseUrl }/manage/organisation/${organisationReference}/welcome-tour`);
    }

    snoozeWelcomeTour(organisationReference: string, model: WelcomeTourPatch) {
        const url = `${ this.configService.baseUrl }/manage/organisation/${organisationReference}/welcome-tour/snooze`;
        return this.http.patch(url, model);
    }

    markWelcomeTourAsComplete(organisationReference: string) {
        const url =`${ this.configService.baseUrl }/manage/organisation/${organisationReference}/welcome-tour/mark-as-completed`;
        return this.http.post<void>(url, null);
    }
}
